import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BASEURL || process.env.REACT_APP_BASE_URL, // adjust the base URL as needed
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    // Ensure proper HTTPS handling
    withCredentials: false,
    timeout: 30000 // 30 second timeout
});

axiosInstance.interceptors.request.use(
    (config) => {
        let token = null;
        const user = localStorage.getItem('user_customer_details');
    
        if (!token && user) token = JSON.parse(user).token;
    
        if (token) config.headers['Authorization'] = `Bearer ${token}`;
        
        // Ensure JSON content type for all requests
        if (!config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/json';
        }
    
        return config;
    },
    (error) => {
      return Promise.reject(error);
    }
);

// Add response interceptor for better error handling
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            // Server responded with error status
            console.error('API Error Response:', error.response.data);
            console.error('API Error Status:', error.response.status);
        } else if (error.request) {
            // Request was made but no response received
            console.error('API Network Error:', error.request);
        } else {
            // Something else happened
            console.error('API Error:', error.message);
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
